// Copyright (c) 2023 Deere & Company

import DuplicatePINPlate, {getDefaultState as getDuplicatePINPlateDefaultState} from '@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate';
import DuplicatePinFormValidation, {getDefaultState as getFormValidationDefaultState} from './duplicate-pin-form-validation';
import t from 'tcomb';

const DuplicatePINPlateRequest = t.struct({
    duplicatePINPlate: DuplicatePINPlate,
    formValidation: DuplicatePinFormValidation,
    isValid: t.Boolean,
    temporaryObjectKey: t.String
}, 'DuplicatePINPlateRequest');

export const getDefaultState = () =>
    new DuplicatePINPlateRequest({
        duplicatePINPlate: getDuplicatePINPlateDefaultState(),
        formValidation: getFormValidationDefaultState(),
        isValid: false,
        temporaryObjectKey: ''
    });

export default DuplicatePINPlateRequest;



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/state/index.js